import PropTypes from 'prop-types'
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

const i18nPrefix = 'pointsOnPayments:paymentWizard.formPanel.ineligibleModal'

const IneligibleModal = ({isOpen, onExit}) => {
  const {t} = useTranslation('pointsOnPayments')

  return (
    <Modal isOpen={isOpen} onClose={() => {}} preserveScrollBarGap>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Text textStyle="body-intro-medium">{t(`${i18nPrefix}.title`)}</Text>
          <hr />
        </ModalHeader>
        <ModalBody>
          <Text>{t(`${i18nPrefix}.body`)}</Text>
        </ModalBody>
        <ModalFooter justifyContent="flex-start">
          <Button variant="primary" onClick={onExit} textTransform="uppercase">
            {t(`${i18nPrefix}.exitButton`)}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

IneligibleModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onExit: PropTypes.func.isRequired,
}

export default IneligibleModal
